import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {
    PageNotFound,
    PageLogin,
    } from './Pages';
import {CustomerPopup} from './Pages/Popup';
import {IsLogged,GetRole} from './Utils/Function';
import {
    PageMemberList
} from './Pages/Member';
import {
    PageCardList
} from './Pages/Card'
import {
    PageStaffHome,
} from './Pages/Staff';
import {
    PageShiftList
} from './Pages/Shift';
import {
    
} from './Pages/Admin';
import {
    PageUserList,
}from './Pages/User';
import {
    PageStoreList
}from './Pages/Store';
import { PageTopupList } from './Pages/Topup';
import { 
    PageSaleList,
    PageAggregateList,
    PageSummary,
    PageStoreSummary
 } from './Pages/Report';
 import {
    PageMonthExport
 }from './Pages/Export';
const Router =() =>{
    if(IsLogged()){
        return (
            <Routes>
                {(GetRole() === 2 ?
                <>
                    <Route path="/" element={<PageNotFound />} />
                </>
                :"")}


                {(GetRole() === 3 ?
                <>
                    <Route path="/" element={<PageStaffHome />} />
                    <Route path="/Staff" element={<PageStaffHome />} />
                </>
                :"")}

                {(GetRole() >= 3 ? 
                <>
                    <Route path="/Member" element={<PageMemberList />} />
                    <Route path="/Card" element={<PageCardList />} />
                    <Route path="/Shift" element={<PageShiftList />} />
                    <Route path="/Report/Summary" element={<PageSummary/>} />
                    <Route path="/Report/Topup" element={<PageTopupList/>} />
                    <Route path="/Report/Sales" element={<PageSaleList/>} />
                    <Route path="/Report/Aggregate" element={<PageAggregateList/>} />
                    <Route path="/Report/Store" element={<PageStoreSummary/>} />
                </>
                :"")}

                {(GetRole() === 9 ?
                <>
                    <Route path="/" element={<PageSummary />} />
                    <Route path="/Admin" element={<PageSummary />}/>
                    <Route path="/Staff" element={<PageStaffHome />} />
                    <Route path="/User" element={<PageUserList />} />
                    <Route path="/Store" element={<PageStoreList />} />
                    <Route path="/Export/Month" element={<PageMonthExport />} />
                </>
                :"")}

                <Route path="*" element={<PageNotFound />} />
            </Routes>
        )
    }else{
        localStorage.setItem('redirect',window.location.href);
        return (
            <Routes>
                <Route path="*" element={<PageLogin />} />
            </Routes>
        )
    }
    
}

export default React.memo(Router)